<template>
<span>
<pazar-sherkati-hero></pazar-sherkati-hero>
<pazar-sherkati-details></pazar-sherkati-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import PageFooter from '@/components/PageFooter';
import PazarSherkatiHero from '@/components/PazarSherkatiHero';
import PazarSherkatiDetails from '@/components/PazarSherkatiDetails';
export default {
    name :'pazarsherkati',
    components:{
     PazarSherkatiHero,
     PazarSherkatiDetails,
        PageFooter
    }

    
};
</script>


